import { Outlet } from 'react-router-dom'
import { useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import SocialSidebar from '../components/SocialSidebar'
import CookieBanner from '../components/CookieBanner'

export default function PublicLayout() {
  const [manageCookies, setManageCookies] = useState(0)

  const handleManageCookies = () => {
    setManageCookies(prev => prev + 1)
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <SocialSidebar />
      <main className="flex-grow" style={{ paddingTop: '68px' }}>
        <Outlet />
      </main>
      <Footer onManageCookies={handleManageCookies} />
      <CookieBanner key={manageCookies} onManage={manageCookies > 0} />
    </div>
  )
}
